import * as React from 'react';
import { ca } from '@cian/analytics';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import { IRegion } from '../types';
import { GeoLinkIcon } from './icon/geo_link_icon';
import { NewHeaderGeoLinkIcon } from './icon/new_header_geo_link_icon';

import { LocationModal } from './location_modal';
import { LocationTooltip } from './location_tooltip';

const style = require('./geo_switcher_view.css');

interface IGeoSwitcherViewProps extends React.Props<Location> {
  currentLocation: IRegion;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  popularCities?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onAcceptLocation(region: IRegion): any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDeclineLocation?(): any;
  withTooltip: boolean;
  newHeaderEnabled: boolean;
}

interface IGeoSwitcherViewState {
  isModalOpened: boolean;
  isTooltipOpened: boolean;
  leftOffset?: number;
}

export class GeoSwitcherView extends React.Component<IGeoSwitcherViewProps, IGeoSwitcherViewState> {
  private headerContainer: HTMLElement | null;

  public constructor(props: IGeoSwitcherViewProps) {
    super(props);

    this.state = {
      isTooltipOpened: true,
      isModalOpened: false,
      leftOffset: 0,
    };
  }

  public componentDidMount() {
    this.headerContainer = document.getElementById('header-container');

    this.computeLeftOffset();
    window.addEventListener('resize', this.computeLeftOffset);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.computeLeftOffset);
  }

  /**
   * Вычисляем абсолютный сдвиг слева,
   * для того чтобы выровнить geoSwitcher относительно логотипа
   */
  private computeLeftOffset = () => {
    if (!this.headerContainer) {
      return;
    }

    const { paddingLeft, marginLeft } = window.getComputedStyle(this.headerContainer);
    const leftOffset = parseInt(paddingLeft, 10) + parseInt(marginLeft, 10);

    this.setState({ leftOffset });
  };

  public render() {
    const { displayName } = this.props.currentLocation;
    const { newHeaderEnabled } = this.props;
    const cssClassLink = newHeaderEnabled ? 'new-header-geo-switcher' : 'c-header-top-link';
    const cssClassItem = newHeaderEnabled ? 'text' : 'c-header-top-menu-item';
    const GeoLinkComponent = newHeaderEnabled ? NewHeaderGeoLinkIcon : GeoLinkIcon;

    return (
      <React.Fragment>
        <a
          href="#"
          onClick={this.handleLocationLinkClick}
          {...mergeStyles(cssClassLink, cssClassItem, { left: this.state.leftOffset })}
        >
          <GeoLinkComponent className={style['geo-link']} />
          {displayName}
        </a>
        {!newHeaderEnabled && this.props.withTooltip && this.state.isTooltipOpened && (
          <LocationTooltip
            displayName={displayName}
            onAccept={this.handleAcceptCurrentLocation}
            onDecline={this.handleDeclineLocation}
            onClose={this.closeTooltip}
          />
        )}
        {this.state.isModalOpened && (
          <LocationModal
            popularCities={this.props.popularCities}
            onAcceptLocation={this.handleAcceptLocation}
            onClose={this.closeModal}
          />
        )}
      </React.Fragment>
    );
  }

  private openModal = () => {
    this.setState({
      isModalOpened: true,
    });
  };

  private closeModal = () => {
    this.setState({
      isModalOpened: false,
    });
  };

  private closeTooltip = () => {
    this.setState({
      isTooltipOpened: false,
    });
  };

  private handleAcceptLocation = (location: IRegion) => {
    this.props.onAcceptLocation(location);

    this.closeTooltip();
    this.closeModal();

    ca('event', {
      name: 'oldevent',
      category: 'GEO_block',
      action: 'save_region',
      label: location.displayName,
    });
  };

  private handleAcceptCurrentLocation = (): void => {
    this.handleAcceptLocation(this.props.currentLocation);
  };

  private handleDeclineLocation = (): void => {
    this.closeTooltip();
    this.openModal();

    if (this.props.onDeclineLocation) {
      this.props.onDeclineLocation();
    }
  };

  private handleLocationLinkClick = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    this.openModal();

    ca('event', {
      name: 'oldevent',
      category: 'GEO_block',
      action: 'click_to_change',
    });
  };
}
